import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'

/**
 * Authenticated Layout
 *
 * Layout for all authenticated pages
 * - Collapsible left sidebar navigation (includes a "What's New" entry)
 * - Main content area (Outlet for nested routes)
 * - Bug report button in sidebar navigation
 *
 * The What's New banner that used to live at the top of every page
 * was removed per analyst feedback: the same content is one click
 * away in the sidebar, so a banner on top of every workspace adds
 * vertical clutter without new information.
 */
export function AuthenticatedLayout() {
  return (
    <div className="flex flex-col md:flex-row h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto bg-background min-h-0">
        <Outlet />
      </main>
    </div>
  )
}
